var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { SubAPI } from "./SubAPI";
var EquipmentAPI = /** @class */ (function (_super) {
    __extends(EquipmentAPI, _super);
    function EquipmentAPI() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    EquipmentAPI.prototype.list = function (props) { return this.fetcher.get("/api/equipments", props); };
    EquipmentAPI.prototype.listForAutoComplete = function () { return this.fetcher.get("/api/equipments/auto-complete"); };
    EquipmentAPI.prototype.get = function (id) { return this.fetcher.get("/api/equipment", { id: id }); };
    EquipmentAPI.prototype.create = function (employee) { return this.fetcher.post("/api/equipment/create", employee); };
    EquipmentAPI.prototype.update = function (employee) { return this.fetcher.post("/api/equipment/update", employee); };
    EquipmentAPI.prototype.removeRates = function (props) { return this.fetcher.post("/api/equipment/rate/archive", props); };
    EquipmentAPI.prototype.listRates = function (props) { return this.fetcher.get("/api/equipment/rates", props); };
    EquipmentAPI.prototype.createRate = function (props) { return this.fetcher.post("/api/equipment/rate", props); };
    EquipmentAPI.prototype.updateRate = function (props) { return this.fetcher.post("/api/equipment/rate/update", props); };
    EquipmentAPI.prototype.listFiles = function (input) { return this.fetcher.get("/api/equipment/files", input); };
    EquipmentAPI.prototype.removeFiles = function (input) { return this.fetcher.post("/api/equipment/files/bulk-archive", input); };
    EquipmentAPI.prototype.uploadFile = function (input) { return this.fetcher.postFormData("/api/equipment/file/upload", { info: JSON.stringify(input.info), file: input.file }); };
    return EquipmentAPI;
}(SubAPI));
export { EquipmentAPI };
